import { useMap } from '@vis.gl/react-google-maps';
import { MarkerItem } from '../marker/MarkerComponents';
import { useMarkerClusterer } from '../../hooks/useMarkerClusterer';

export function ClusteredMarkers({ pins, displayLabels, onMarkerClick }) {
    const map = useMap();
    const clusterer = useMarkerClusterer(map);

    return (
        <>
            {pins.map((pin) => (
                <MarkerItem
                    key={`clustered-marker-${pin.id}`}
                    marker={pin}
                    color={displayLabels.find(label => label.id === pin.labelId)?.color || "#000"}
                    onClick={onMarkerClick}
                    clusterer={clusterer}
                />
            ))}
        </>
    );
}
